import { ArrowRight, PhoneCall } from 'lucide-react';
import { WHATSAPP_LINK, SITE } from '../lib/site';

/**
 * Banda CTA final — sección de cierre con conversión máxima.
 * Fondo clay, contraste con el sitio claro.
 */
const CtaBanner = () => {
  return (
    <section className="bg-clay text-paper overflow-hidden relative">
      <div className="absolute inset-0 blueprint-grid opacity-20" aria-hidden="true" />
      <div className="absolute -right-24 -top-24 w-96 h-96 rounded-full bg-ink/15 blur-2xl" aria-hidden="true" />
      <div className="relative max-w-[1400px] mx-auto px-6 py-24 md:py-32 text-center">
        <p className="label !text-paper/80 justify-center reveal">Empieza hoy</p>
        <h2 className="reveal font-display font-black uppercase tracking-[-0.02em] text-[clamp(2.4rem,6vw,5rem)] leading-[0.98] mt-6 max-w-4xl mx-auto">
          Tu reforma empieza con <em className="font-serifit normal-case font-normal text-ink">una visita</em>
        </h2>
        <p className="reveal mt-6 text-paper/85 max-w-xl mx-auto text-lg leading-relaxed">
          Medimos, escuchamos y te entregamos un presupuesto detallado en 24–48h.
          Gratis, sin compromiso y con plazos por escrito.
        </p>
        <div className="reveal mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href={WHATSAPP_LINK('Hola, quiero empezar mi proyecto. ¿Podemos concertar una visita?')}
            target="_blank"
            rel="noopener noreferrer"
            className="btn bg-ink text-paper"
            data-size="lg"
          >
            Pedir presupuesto gratis
            <ArrowRight size={18} />
          </a>
          <a href={`tel:${SITE.phone}`} className="btn border-2 border-paper/70 text-paper hover:bg-paper hover:text-clay transition-colors" data-size="lg">
            <PhoneCall size={17} />
            {SITE.phoneDisplay}
          </a>
        </div>
        <p className="reveal mt-8 text-[0.7rem] font-semibold uppercase tracking-[0.2em] text-paper/60">
          +87 clientes valoran nuestro trabajo con 4,9/5 estrellas
        </p>
      </div>
    </section>
  );
};

export default CtaBanner;
